import { UIOverlayViewStatus } from 'common-ts/dist/models/UIOverlayViewStatus';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface OverlayRepurchaseState {
  status: UIOverlayViewStatus,

  promoCodeRedirectOverlay: string[] | undefined,
  promoCodeRedirectOverlayCountdown: string | undefined,
}

// Define the initial state using that type
const initialState: OverlayRepurchaseState = {
  status: UIOverlayViewStatus.OffAndReady,

  promoCodeRedirectOverlay: localStorage.getItem('promooverlay') !== null ? 
  JSON.parse(localStorage.getItem('promooverlay') as any)?.promoCodeRedirectOverlay : undefined,
  promoCodeRedirectOverlayCountdown:  localStorage.getItem('promooverlay') !== null ? 
  JSON.parse(localStorage.getItem('promooverlay') as any)?.promoCodeRedirectOverlayCountdown : undefined,
}

export const overlayQrRepurchaseSlice = createSlice({
  name: 'overlayQrRepurchase',
  initialState,
  reducers: {
    setRedirectOverlay: (state, action: PayloadAction<{
      promoCodeRedirectOverlay: string[] | undefined,
      promoCodeRedirectOverlayCountdown:  string | undefined,
    }>) => {
      localStorage.setItem('promooverlay', JSON.stringify(action.payload));
      if (action.payload.promoCodeRedirectOverlay?.length) {
        state.promoCodeRedirectOverlay = action.payload.promoCodeRedirectOverlay;
        state.promoCodeRedirectOverlayCountdown = action.payload.promoCodeRedirectOverlayCountdown ?
         action.payload.promoCodeRedirectOverlayCountdown : undefined;
        state.status = UIOverlayViewStatus.On;
      } else {
        state.promoCodeRedirectOverlay = undefined;
        state.promoCodeRedirectOverlayCountdown = undefined;
        state.status = UIOverlayViewStatus.OffAndReady;
      }
    },
    closeOverlayAndReset: (state) => {
      state.status = UIOverlayViewStatus.OffAndReady;
    },

    openOverlay: (state) => {
      state.status = UIOverlayViewStatus.On;
    },
  },
  extraReducers(builder) {
  }
})

// Action creators are generated for each case reducer function
export const { closeOverlayAndReset, openOverlay, setRedirectOverlay } = overlayQrRepurchaseSlice.actions

export default overlayQrRepurchaseSlice.reducer